module.exports = __webpack_public_path__ + "static/media/inventory.95b68fa8.svg";